module.exports = __webpack_public_path__ + "img/government-affairs-icon-hover.3c5a5a5e.png";